'use client';

import { Box, Center, Text } from '@mantine/core';
import CopyButton from '@ui-kit/atoms/CopyButton';
import * as classes from './styles/index.css';
import useWorkspace from '@features/Workspace/store/hooks/useWorkspace';
import { getResourceURL } from '@helpers/share';
import { IconLink } from '@tabler/icons-react';
import { CellProps } from '../types';
import { FONT_WEIGHT } from '@app/shared/ui-kit/fonts';
import { ResourceRowFragmentFragment } from '@app/types/blackroom-api';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function CellPublicId({ row }: CellProps<ResourceRowFragmentFragment>) {
  /* ********************************** HOOKS ********************************* */
  const workspace = useWorkspace();

  /* ***************************** LOCAL VARIABLES **************************** */

  const resource = row.original;

  /* ******************************** RENDERING ******************************* */

  return (
    <Box w="100%" className={classes.cellPublicId}>
      {/* Hidden on hover */}
      <Text fw={FONT_WEIGHT.lighter} className={classes.cellPublicIdText}>
        {resource.publicId}
      </Text>

      {/* Only visible on hover */}
      <Center h="100%" w="100%" className={classes.cellPublicIdLink}>
        <CopyButton
          value={getResourceURL(resource, workspace)}
          tooltipProps={{ position: 'top' }}
          iconCopy={IconLink}
        />
      </Center>
    </Box>
  );
}

export default CellPublicId;
